import { render, staticRenderFns } from "./onpageLogin.vue?vue&type=template&id=097d43f8&"
import script from "./onpageLogin.vue?vue&type=script&lang=js&"
export * from "./onpageLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports